import { PersonalProfile } from '../types';

interface AboutProps {
  profile: PersonalProfile;
  experienceStartYear: number;
}

function About({ profile, experienceStartYear }: AboutProps) {
  const yearsExperience = new Date().getFullYear() - experienceStartYear - 2;

  return (
    <div id="fh5co-about" className="animate-box">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2>About Me</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <ul className="info">
              <li><span className="first-block">Full Name:</span><span className="second-block">Pablo Magro Gaspar</span></li>
              <li><span className="first-block">Email:</span><span className="second-block">{profile.email}</span></li>
            </ul>
          </div>
          <div className="col-md-8">
            <h2>Hello There!</h2>
            <br />
            <p>
              {profile.bio.replace('{years}', String(yearsExperience))}
            </p>
            <p>
              <ul className="fh5co-social-icons">
                {profile.socialLinks.map((link) => (
                  <li key={link.url}><a href={link.url}><i className={link.icon}></i></a></li>
                ))}
              </ul>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
